import React, { Fragment } from 'react';
import { useUrlLocalizer, useTranslator } from 'tradera-lang';

const SellerName = ({
    memberId,
    cleanedAlias,
    alias,
    hasBackground,
    isCompany,
    hasShop
}) => {
    const { toLocalizedUrl } = useUrlLocalizer();
    const { t } = useTranslator();

    const badgeText =
        (hasShop && t('vip_sellerInfoHasStore')) ||
        (isCompany && t('vip_sellerInfoCompany'));

    return (
        <Fragment>
            <div
                className={`row py-4 py-md-5 ${
                    hasBackground
                        ? 'mx-n4 mx-md-n5 border-bottom bg-gray-100 gray-300'
                        : ''
                }`}>
                <div
                    className={`col-12 d-flex align-items-center flex-nowrap ${
                        hasBackground ? 'p-0 mx-4 mx-md-5' : ''
                    }`}>
                    {badgeText && (
                        <span className="badge badge-success mr-3">
                            {badgeText}
                        </span>
                    )}
                    <a
                        href={toLocalizedUrl(
                            `/profile/items/${memberId}/${cleanedAlias}`
                        )}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="text-primary text-styled h3 font-weight-bold m-0">
                        {alias}
                    </a>
                </div>
            </div>
        </Fragment>
    );
};

export default SellerName;
